import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Params = {
  orderId: string
}

export type Response = {
  data: {
    orderId: string
    customer: string
    cnpjCpf: string
    register: string
    totalOrder: number
    orderDate: string
    products: {
      sequence: number
      quantityUn: number
      productId: string
      configurationId: string
      salePrice: number
      balance: number
      quantityRule: string
    }[]
  }
}

const loadFutureDelivery = (params: Params): Promise<Response> => {
  return axios.get(`orders/${params.orderId}/future-delivery`, {
    params: {
      page: 1,
      limit: 100,
      ...params
    }
  })
}

export function useLoadFutureDelivery(params: Params) {
  return useQuery(
    ['loadFutureDelivery', params],
    () => loadFutureDelivery(params),
    {
      enabled: !!params?.orderId,
      onError: () =>
        toast.error('Não foi possível carregar o pedido de entrega futura', {
          toastId: 'loadFutureDelivery'
        })
    }
  )
}
